<template>
  <el-drawer v-model="drawer" title="商品详情" custom-class="customDrawer" size="375px"  :before-close="handleClose">
    <div class='picture-box' v-if='goods.pictureList&&goods.pictureList.length>0'>
      <el-carousel height="375px">
        <el-carousel-item v-for="item in goods.pictureList" :key="item">
          <img :src="filePath+item.url"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class='goods-info-box'>
      <div class="price-box">
        <div class="sell-money" v-if="goods.storeGoodsType!==1">
          <text>￥</text>
          {{goods.salesPrice}}
          <div class='price' v-if="goods.storeGoodsType!==2&&goods.price">原价￥{{goods.price.toFixed(2)}}</div>
        </div>
        <div class="lease-money" :class="{ml:goods.storeGoodsType!==1}" v-if="goods.storeGoodsType===1||goods.storeGoodsType===2">
          <div class="tag">
            <text>租</text>
          </div>
          <div class="money">￥{{goods.marketPrice}}<text>/天</text></div>
        </div>
      </div>
      <div class='goods-name'>
        {{goods.name}}
      </div>
    </div>
    <div class='goods-detail'>
      <div class='title'>商品详情</div>
      <div class='rich-box' v-html='filterHtml(goods.goodsDetails)'></div>
    </div>
  </el-drawer>
</template>

<script>

export default {
  name: "goods-detail-mobile",
  data() {
    return {
      drawer:false,
      goods:null,
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose(){
      this.drawer = false;
    },
    filterHtml(content){
        if(!content){
            return content;
        }
        content = content.replace(/\n/g, "<br/>");
        return content.replace(/<(img).*?(\/>|<\/img>)/g, function (mats) {
            if (mats.indexOf('style') < 0) {
                return mats.replace(/<\s*img/, '<img style="max-width:100%;height:auto;"')
            } else {
                return mats.replace(/style=("|')/, 'style=$1max-width:100%;height:auto;')
            }
        })
    },
    openDrawer(id,goodsType){
      this.simpleGet("/api/mp/business/goods/detail",{id:id,goodsType:goodsType},res=>{
        this.goods = res.data;
        this.drawer = true;
      })
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>

.picture-box{
  width: 375px;
  height: 375px;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.goods-info-box{
  background: #FFFFFF;
  padding: 16px 12px;

  .goods-name{
    margin: 9px 0;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
}
.goods-detail{
  margin-top: 8px;
  background: #FFFFFF;
  padding: 14px 0;
  .title{
    margin-left: 24px;
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
}
.price-box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .sell-money{
    font-family: 'DIN';
    font-weight: bold;
    font-size: 20px;
    color: #7E492E;
    display: flex;
    align-items: center;
    text{
      font-weight: 400;
      font-size: 18px;
      margin-right: 2px;
    }
    .price{
      margin-left: 5px;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      text-decoration-line: line-through;
    }
  }
  .lease-money{
    height: 14px;
    display: flex;
    align-items: center;
    border: 1px solid #E6E5E5;
    box-sizing: border-box;
    margin-left: 6px;
    &.ml{
      margin-left: 14px;
    }
    .tag{
      width: 19px;
      height: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: linear-gradient( 148deg, #18DB9D 0%, #238527 100%);
      border-radius: 2px;
      transform: skewX(-15deg) translateX(-6px);
      text{
        transform: skewX(15deg);
        font-weight: bold;
        font-size: 11px;
        color: #FFFFFF;
        line-height: 9px;
      }
    }
    .money{
      padding-right:14px;
      font-family: 'DIN';
      font-weight: bold;
      font-size: 12px;
      color: #333333;
      text{
        font-size: 10px;
        font-weight: unset;
      }
    }
  }
}
.rich-box {
  width: calc(100vw + (100% - 100vw));
  ::deep img {
    display: block;
    margin: 0 auto;
    max-width: 100% !important;
    height: auto !important;
  }
  ::deep p {
    max-width: 100%;
    word-break: break-all;
    font-size: 15px !important;
    margin: 0;
  }
  /deep/ img {
    display: block;
    margin: 0 auto;
    max-width: 100% !important;
    height: auto !important;
  }
  /deep/ p {
    max-width: 100%;
    word-break: break-all;
    font-size: 15px !important;
    margin: 0;
  }

  table {
    width: 100%;
  }
}
</style>
